<template>
  <div>
    <v-row justify="center">
      <v-col class="text-center">
        <span class="h3">Tokenomics <span class="white--text">Breakdown</span></span>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <div class="token-info">
          <div class="token-left">
            <div class="header">
              <div class="title">TOKEN NAME:</div>
              <div class="description">GGT</div>
            </div>

            <div class="body">
              <div class="title">INITIAL CIRCULATING SUPPLY:</div>
              <div class="description">2.125M</div>
            </div>
            <div class="body">
              <div class="title">INITIAL MARKET CAP:</div>
              <div class="description">$233K</div>
            </div>
            <div class="body">
              <div class="title">ESTIMATED LISTING:</div>
              <div class="description">Q1 2022</div>
            </div>
          </div>

          <div class="token-right">
            <div class="header">
              <div class="title">TOKEN TYPE:</div>
              <div class="description">BEP20 (BSC)</div>
            </div>

            <div class="body">
              <div class="title">TGE TOKEN PRICE:</div>
              <div class="description">$0.1100</div>
            </div>
            <div class="body">
              <div class="title">HARD CAP:</div>
              <div class="description">$2M</div>
            </div>
            <div class="body">
              <div class="title">TOTAL SUPPLY:</div>
              <div class="description">125M</div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  
};
</script>

<style lang="scss" scoped>
.token-info {
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media (max-width: 767px){
    flex-direction: column;
  }
}

.tokenomic {
  flex-direction:column;
  width: 100%;
  max-width: 100%;
}

.token {
  box-shadow: 0px 24px 38px rgb(0 0 0 / 7%), 0px 9px 46px rgb(0 0 0 / 6%), 0px 11px 15px rgb(0 0 0 / 10%);
  border-radius: 14px;
  display: flex;

  @media (max-width: 767px) {
    margin-bottom: 16px;
  }

  &-left {
    margin-right: 24px;
  }

  &-right {
    @media (max-width: 767px) {
      margin-top: 16px;
    }
  }

  &-left, &-right {
    width: 500px;
    max-width: 100%;

    border-radius: 10px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)) !important;

    .title {
      font-size: 16px;
      line-height: 16px;
      letter-spacing: 1.25px;
    }

    .description {
      font-size: 24px;
      line-height: 36px;
      // color: #00fefe;
      color: #eca93e;
    }

    .title, .description {
      justify-content: center;
      align-items: center;
      display: flex;
      font-weight: bold;
    }

    .header {
      color: #fff !important;
      background: linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)) !important;
    }

    .header, .body {
      color: #fff;
      display: flex;
      justify-content: space-between;
      width: 100%;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      padding: 20px;

      @media (max-width: 767px){
        flex-direction:column;
      }

    }

    .body:nth-child(odd) {
      background: linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)) !important;
      border-top-right-radius: 0;
      border-top-left-radius: 0;
    }
  }
}
</style>